import React from "react";
import { LinkPreviewData } from "hooks/useLinkPreview";
import "./style.scss";

interface Props {
  preview: LinkPreviewData;
}

function LinkPreview({ preview }: Props) {
  if (!preview.title && !preview.description && !preview.image) return null;

  const domain = (() => {
    try {
      return new URL(preview.url).hostname.replace(/^www\./, "");
    } catch {
      return preview.siteName || "";
    }
  })();

  const cls = ["link-preview"];
  if (preview.image) cls.push("__has-image");
  else cls.push("__compact");

  return (
    <a
      className={cls.join(" ")}
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
    >
      {preview.image && (
        <div className="link-preview__image">
          {/* width/height hint the layout slot before decode; the parent
              <div> reserves the matching slot via SCSS min-height so the
              chat viewport doesn't snap when the OG image arrives. */}
          <img src={preview.image} alt="" loading="lazy" width={400} height={200} />
        </div>
      )}
      <div className="link-preview__body">
        {(preview.siteName || domain) && (
          <div className="link-preview__site-name">{preview.siteName || domain}</div>
        )}
        {preview.title && <div className="link-preview__title">{preview.title}</div>}
        {preview.description && (
          <div className="link-preview__description">{preview.description}</div>
        )}
        {preview.image && <div className="link-preview__domain">{domain}</div>}
      </div>
    </a>
  );
}

export default LinkPreview;
